import { render, staticRenderFns } from "./SACSettingMenu.vue?vue&type=template&id=213edce6"
import script from "./SACSettingMenu.vue?vue&type=script&lang=js"
export * from "./SACSettingMenu.vue?vue&type=script&lang=js"
import style0 from "./SACSettingMenu.vue?vue&type=style&index=0&id=213edce6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports